import { PaymentStatus } from '../XV2';

export function isPaymentSuccessful(status: PaymentStatus) {
    return [PaymentStatus.AUTHORISED, PaymentStatus.SETTLED].includes(status);
}
